import { ServiceResult } from '../models/api-shared.models';
import {
  CreateThirdPartyInvoiceHeaderRequest,
  DeleteThirdPartyInvoiceDetailRequest,
  DeleteThirdPartyInvoiceHeaderRequest,
  GetThirdPartyInvoiceHeadersRequest,
  QuickAddThirdPartyInvoiceDetailRequest,
  ThirdPartyInvoiceDetail,
  ThirdPartyInvoiceHeader,
  UpdateThirdPartyInvoiceDetailsRequest,
  UpdateThirdPartyInvoiceHeaderRequest,
} from '../models/third-party-invoice.models';
import ApiService from './api-service';

class ThirdPartyInvoiceService extends ApiService {
  private static classInstance: ThirdPartyInvoiceService;

  private constructor() {
    super('ThirdPartyInvoice');
  }

  public async getThirdPartyInvoiceHeaders(
    request: GetThirdPartyInvoiceHeadersRequest
  ): ServiceResult<ThirdPartyInvoiceHeader[]> {
    return this.post(`${this.baseUrl}/GetThirdPartyInvoiceHeaders`, request);
  }

  public async getThirdPartyInvoiceHeader(thirdPartyInvoiceHeaderId: string): ServiceResult<ThirdPartyInvoiceHeader> {
    return this.get(
      `${this.baseUrl}/GetThirdPartyInvoiceHeader?thirdPartyInvoiceHeaderId=${thirdPartyInvoiceHeaderId}`
    );
  }

  public async createThirdPartyInvoiceHeader(
    request: CreateThirdPartyInvoiceHeaderRequest
  ): ServiceResult<ThirdPartyInvoiceHeader> {
    return this.post(`${this.baseUrl}/CreateThirdPartyInvoiceHeader`, request);
  }

  public async updateThirdPartyInvoiceHeader(
    request: UpdateThirdPartyInvoiceHeaderRequest
  ): ServiceResult<ThirdPartyInvoiceHeader> {
    return this.post(`${this.baseUrl}/UpdateThirdPartyInvoiceHeader`, request);
  }

  public async deleteThirdPartyInvoiceHeader(request: DeleteThirdPartyInvoiceHeaderRequest): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/DeleteThirdPartyInvoiceHeader`, request);
  }

  public async getThirdPartyInvoiceDetails(
    thirdPartyInvoiceHeaderId: string
  ): ServiceResult<ThirdPartyInvoiceDetail[]> {
    return this.get(
      `${this.baseUrl}/GetThirdPartyInvoiceDetails?thirdPartyInvoiceHeaderId=${thirdPartyInvoiceHeaderId}&isEditing=false`
    );
  }

  public async deleteThirdPartyInvoiceDetail(request: DeleteThirdPartyInvoiceDetailRequest): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/DeleteThirdPartyInvoiceDetail`, request);
  }

  public async quickAddThirdPartyInvoiceDetail(
    request: QuickAddThirdPartyInvoiceDetailRequest
  ): ServiceResult<ThirdPartyInvoiceDetail[]> {
    return this.post(`${this.baseUrl}/QuickAddThirdPartyInvoiceDetail`, request);
  }

  public async submitThirdPartyInvoicePrice(request: ThirdPartyInvoiceHeader): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/SubmitThirdPartyInvoicePrice`, request, 'queryParams');
  }

  public async updateThirdPartyInvoiceDetails(
    request: UpdateThirdPartyInvoiceDetailsRequest
  ): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/UpdateThirdPartyInvoiceDetails`, request);
  }

  public static getInstance(): ThirdPartyInvoiceService {
    if (!this.classInstance) {
      this.classInstance = new ThirdPartyInvoiceService();
    }
    return this.classInstance;
  }
}

export default ThirdPartyInvoiceService;
